import {
  FaceIdRegistrationStatus,
  ProfileStatus,
  ProfileType,
} from '@/features/face-id-profiles/enums';

import { ITableCellStatus, ITableCellTag } from '@/components/common/Table/Table.interfaces';

export const getProfileStatusLabel = (status: ProfileStatus): string => {
  switch (status) {
    case ProfileStatus.Active:
      return 'Active';
    case ProfileStatus.Inactive:
      return 'Inactive';
  }
};

export const getProfileStatusVariant = (status: ProfileStatus): ITableCellTag['tagVariant'] => {
  switch (status) {
    case ProfileStatus.Active:
      return 'active';
    case ProfileStatus.Inactive:
      return 'inactive';
    default:
      return 'default';
  }
};

export const getFaceIdRegistrationStatusLabel = (status: FaceIdRegistrationStatus): string => {
  switch (status) {
    case FaceIdRegistrationStatus.Pending:
      return 'Pending';
    case FaceIdRegistrationStatus.Registered:
      return 'Registered';
  }
};

export const getFaceIdRegistrationStatusVariant = (
  status: FaceIdRegistrationStatus,
): ITableCellStatus['statusVariant'] => {
  switch (status) {
    case FaceIdRegistrationStatus.Pending:
      return 'pending';
    case FaceIdRegistrationStatus.Registered:
      return 'completed';
    default:
      return 'default';
  }
};

export const getProfileTypeLabel = (type: ProfileType): string => {
  switch (type) {
    case ProfileType.Employee:
      return 'Employee';
    case ProfileType.Guest:
      return 'Guest';
  }
};
